import CircularFilledIcon, { CircularFilledIconProps } from "@/components/CircularButton/styled/CircularFilledIcon";
import CircularOutlineIcon, { CircularOutlineIconProps } from "@/components/CircularButton/styled/CircularOutlineIcon";
import { themeColors } from "@/utils/themeColors";
import { ArrowLeft, ArrowRight, Check, X } from "lucide-react";

export const CarouselNavBtn = ({
    onClick,
    isNextBtn,
    isPrevBtn,
    disabled,
    ...props
}: Partial<CircularOutlineIconProps> & {
    isNextBtn?: boolean;
    isPrevBtn?: boolean;
}) => {
    const Icon = isNextBtn ? ArrowRight : isPrevBtn ? ArrowLeft : ArrowLeft;

    return (
        <CircularOutlineIcon
            radius="3rem"
            onClick={onClick}
            buttonColor={themeColors.primary}
            disabled={disabled}
            color={themeColors.primaryDark}
            strokeWidth={3}
            {...props}
            size={30}
            Icon={Icon}
        />
    );
};

export const CarouselSortBtn = ({
    onClick,
    isKnow,
    isDKnow,
    ...props
}: Partial<CircularOutlineIconProps> & { isKnow?: boolean; isDKnow?: boolean }) => {
    const Icon = isDKnow ? X : isKnow ? Check : Check;
    const buttonColor = isKnow ? themeColors.successSecondary : isDKnow ? themeColors.errorSecondary : undefined;
    const color = isKnow ? themeColors.successPrimary : isDKnow ? themeColors.errorPrimary : undefined;
    const hoverBackgroundColor = isKnow ? themeColors.successPrimary : isDKnow ? themeColors.errorPrimary : undefined;

    return (
        <CircularOutlineIcon
            radius="3rem"
            onClick={onClick}
            buttonColor={buttonColor}
            hoverColor={themeColors.neutralBlack}
            hoverBackgroundColor={hoverBackgroundColor}
            color={color}
            borderColor={color}
            sx={{ borderWidth: "2px" }}
            strokeWidth={4}
            {...props}
            size={30}
            Icon={Icon}
        />
    );
};

export const CarouselControlBtn = ({
    isActive,
    Icon,
    onClick,
    IconProps,
    sx,
    ...props
}: CircularFilledIconProps & { isActive?: boolean }) => {
    return (
        <CircularFilledIcon
            Icon={Icon}
            IconProps={{
                size: 20,
                strokeWidth: 2,
                color: isActive ? themeColors.primary : undefined,
                ...IconProps,
            }}
            sx={{ width: "4rem", height: "4rem", ...sx }}
            onClick={onClick}
            {...props}
        />
    );
};
